/* eslint-disable */
export const Colors = {
  baseBrand50: "#322447",
  baseBrand100: "#3d2c56",
  baseBrand200: "#543680",
  baseBrand300: "#724EA7",
  baseBrand400: "#9167CD",
  baseBrand500: "#AF80F4",
  baseBrand600: "#BF99F6",
  baseBrand700: "#CFB3F8",
  baseBrand800: "#DFCCFB",
  baseBrand900: "#E7D9FC",
  baseSteel50: "#38393d",
  baseSteel100: "#313235",
  baseSteel200: "#494b50",
  baseSteel300: "#57585c",
  baseSteel400: "#95989d",
  baseSteel500: "#c9cbcf",
  baseSteel600: "#d1d3d6",
  baseSteel700: "#dfe0e2",
  baseSteel800: "#f7f8f9",
  baseSteel900: "#fff",
  baseGray50: "#070708",
  baseGray100: "#0E0E0F",
  baseGray200: "#2b2b2e",
  baseGray300: "#1B1C1E",
  baseGray400: "#2E2F33",
  baseGray500: "#36353b",
  baseGray600: "#414045",
  baseGray700: "#504f54",
  baseGray800: "#6F6E74",
  baseGray900: "#838288",
  baseBlue50: "#000B19",
  baseBlue100: "#152E51",
  baseBlue200: "#1D3A63",
  baseBlue300: "#3663A1",
  baseBlue400: "#4880CF",
  baseBlue500: "#5A9DFC",
  baseBlue600: "#7BB1FD",
  baseBlue700: "#9CC4FD",
  baseBlue800: "#BDD8FE",
  baseBlue900: "#DEEBFE",
  baseGreen50: "#03110B",
  baseGreen100: "#0B412B",
  baseGreen200: "#0F5235",
  baseGreen300: "#16784F",
  baseGreen400: "#1D9B66",
  baseGreen500: "#23BD7D",
  baseGreen600: "#41C890",
  baseGreen700: "#5FD2A3",
  baseGreen800: "#7EDDB5",
  baseGreen900: "#ABEDD2",
  baseRed50: "#230001",
  baseRed100: "#4F1618",
  baseRed200: "#7B2D2F",
  baseRed300: "#A74345",
  baseRed400: "#D35A5C",
  baseRed500: "#FF7073",
  baseRed600: "#FF8D8F",
  baseRed700: "#FFA9AB",
  baseRed800: "#FFC6C7",
  baseRed900: "#FFE2E3",
  baseYellow50: "#1C0F03",
  baseYellow100: "#512F10",
  baseYellow200: "#603915",
  baseYellow300: "#995D25",
  baseYellow400: "#C37730",
  baseYellow500: "#ED913B",
  baseYellow600: "#F1A762",
  baseYellow700: "#F4BD89",
  baseYellow800: "#F8D3B1",
  baseYellow900: "#FBE9D8",
  baseMagenta50: "#220012",
  baseMagenta100: "#4E1432",
  baseMagenta200: "#7A2751",
  baseMagenta300: "#A53B71",
  baseMagenta400: "#D14E90",
  baseMagenta500: "#FD62B0",
  baseMagenta600: "#FD81C0",
  baseMagenta700: "#FEA1D0",
  baseMagenta800: "#FEC0DF",
  baseMagenta900: "#FED0E7",
  interactivePrimaryDefault: "#AF80F4",
  interactivePrimaryActive: "#AF80F4",
  interactivePrimaryHover: "#BF99F6",
  interactivePrimaryPressed: "#CFB3F8",
  interactivePrimaryDisabled: "#724EA7",
  interactiveSuccessDefault: "#23BD7D",
  interactiveSuccessHover: "#41C890",
  interactiveSuccessPressed: "#5FD2A3",
  interactiveSuccessActive: "#5FD2A3",
  interactiveSuccessDisabled: "#16784F",
  interactiveWarningDefault: "#ED913B",
  interactiveWarningHover: "#F1A762",
  interactiveWarningPressed: "#F4BD89",
  interactiveWarningDisabled: "#995D25",
  interactiveCriticalDefault: "#FF7073",
  interactiveCriticalHover: "#FF8D8F",
  interactiveCriticalPressed: "#FFA9AB",
  interactiveCriticalDisabled: "#A74345",
  interactiveInfoDefault: "#5A9DFC",
  interactiveInfoHover: "#7BB1FD",
  interactiveInfoPressed: "#9CC4FD",
  interactiveInfoDisabled: "#3663A1",
  interactiveNeutralDefault: "#2E2F33",
  interactiveNeutralHover: "#36353b",
  interactiveNeutralPressed: "#414045",
  interactiveNeutralDisabled: "#504f54",
  backgroundViewDarker: "#38393d",
  backgroundViewHoverBackground: "#322447",
  backgroundViewLighter: "#0E0E0F",
  backgroundViewLight: "#2b2b2e",
  backgroundViewApp: "#1B1C1E",
  backgroundViewHover: "#2E2F33",
  backgroundViewNavi: "#36353b",
  backgroundViewEdit: "#322447",
  backgroundViewAppshell: "#1B1C1E",
  backgroundSystemInfoLight: "#012032",
  backgroundSystemInfoDefault: "#152E51",
  backgroundSystemCritcal: "#4F1618",
  backgroundSystemWarning: "#512F10",
  backgroundSystemSuccess: "#0B412B",
  backgroundPrivateDefault: "#2d2c23",
  backgroundPrivateLight: "#25241d",
  backgroundPrivateDark: "#343228",
  backgroundGradientBrand: "linear-gradient(270deg, #078FE4 0%, #163EA2 100%)",
  backgroundGradientNeutral: "linear-gradient(180deg, #222326 0%, #1d1d20 100%)",
  backgroundGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  backgroundGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  backgroundGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  backgroundGradientPurple: "linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)",
  backgroundGradientOrange: "linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)",
  backgroundGradientRed: "linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)",
  backgroundGradientLightBlue: "linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)",
  backgroundGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  backgroundGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  backgroundGradientFindTimeGray: "repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)",
  backgroundGradientFindTimeBlue: "repeating-linear-gradient(135deg, #362252, #362252 6px, #4B336F 6px, #4B336F 12px)",
  backgroundGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  backgroundGradientMask: "linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%",
  backgroundGradientRainbow: "linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)",
  backgroundGradientGrayToTransparent: "linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)",
  backgroundGradientTellentDefault: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  backgroundGradientTellentPink: "linear-gradient(90deg, #af80f4 0%, #fd62b0 100%)",
  backgroundGradientTellentLightPurple: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
  backgroundGradientAiLightPurple: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
  backgroundGradientGrowDefault: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
  borderNeutralDefault: "#414045",
  borderNeutralDark: "#504f54",
  borderNeutralDisabled: "#36353b",
  borderNeutralTransparent: "rgba(255,255,255,0.3)",
  borderSystemInfo: "#5A9DFC",
  borderSystemSuccess: "#23BD7D",
  borderSystemCritical: "#FF7073",
  borderSystemWarning: "#ED913B",
  borderMainPrimary: "#AF80F4",
  borderMainActive: "#724EA7",
  textSystemInfo: "#7BB1FD",
  textSystemSuccess: "#41C890",
  textSystemWarning: "#F1A762",
  textSystemCritical: "#FF8D8F",
  textMainDefault: "#fff",
  textMainSubdued: "#c9cbcf",
  textMainDisabled: "#57585c",
  textMainActive: "#BF99F6",
  iconSystemInfo: "#5A9DFC",
  iconSystemSuccess: "#23BD7D",
  iconSystemWarning: "#ED913B",
  iconSystemCritical: "#FF7073",
  iconMainBrand: "#AF80F4",
  iconMainDefault: "#fff",
  iconMainSubdued: "#c9cbcf",
  iconMainDisabled: "#57585c",
  iconMainActive: "#7BB1FD",
  miscSpecialPersonal: "#B26D00",
  miscSpecialViolet: "#6473C6",
  miscSpecialOrange: "#db6300",
  miscSpecialOrangeLight: "#1D1A18",
  miscSpecialYellow: "#D19804",
  miscSpecialIndigo: "#0A2463",
  miscSpecialDarkYellow: "#444336",
  miscSpecialDarkBlue: "#0C285E",
  miscSpecialLime: "#709F00",
  miscSpecialGrayDark: "#8997A9",
  miscSpecialGrayLight: "#35363B",
  miscSpecialTurquoise: "#00C1CC",
  miscSpecialTurquoiseLight: "#003A3D",
  miscSpecialPurple: "#AF7FE6",
  miscSpecialPurpleLight: "#432468",
  miscSpecialBrown: "#B38F7F",
  miscSpecialBrownLight: "#402E26",
  miscSocialFacebook: "#1877F2",
  miscSocialTwitter: "#3dacf0",
  miscSocialGooglePlus: "#d34836",
  miscSocialLinkedin: "#2187EC",
  miscSocialX: "#C4C4C4",
  miscPublicDefault: "#219475",
  miscPublicHover: "#239E7D",
  miscPublicSubdued: "#0D3A31",
  pricingScaleDefault: "#219475",
  pricingScaleHover: "#239E7D",
  pricingScaleSubdued: "#0D3A31",
  pricingLeadDefault: "#835EC7",
  pricingLeadHover: "#8D6BCC",
  pricingLeadSubdued: "#23153d",
  pricingOptimizeDefault: "#835EC7",
  pricingOptimizeHover: "#8D6BCC",
  pricingOptimizeSubdued: "#23153d",
  pricingGrowDefault: "#219475",
  pricingGrowHover: "#239E7D",
  pricingGrowSubdued: "#0D3A31",
  pricingStartDefault: "#ffffff",
  pricingStartHover: "#dfe0e2",
  white: "#ffffff",
  black: "#000000",
  colorBgDefault: "#222326",
  colorBgHover: "#2E2F33",
  colorBgActive: "#3d2c56",
  colorBgDisabled: "#414045",
  colorBgSelected: "#3d2c56",
  colorBgPrimaryDefault: "#AF80F4",
  colorBgPrimaryHover: "#BF99F6",
  colorBgPrimaryPressed: "#CFB3F8",
  colorBgPrimarySelected: "#AF80F4",
  colorBgPrimaryDisabled: "#724EA7",
  colorBgPrimarySubduedDefault: "#322447",
  colorBgPrimarySubduedHover: "#322447",
  colorBgPrimarySubduedSelected: "#322447",
  colorBgPrimarySubduedActive: "#322447",
  colorBgPrimaryStrongDefault: "#BF99F6",
  colorBgPrimaryLowDefault: "#3d2c56",
  colorBgPrimaryLowHover: "#3d2c56",
  colorBgPrimaryLowPressed: "#543680",
  colorBgNeutralDefault: "#1B1C1E",
  colorBgNeutralHover: "#36353b",
  colorBgNeutralPressed: "#414045",
  colorBgNeutralDisabled: "#504f54",
  colorBgNeutralSelected: "#2E2F33",
  colorBgNeutralLowDefault: "#2b2b2e",
  colorBgNeutralLowHover: "#38393d",
  colorBgNeutralLowDisabled: "#1B1C1E",
  colorBgNeutralStrongDefault: "#414045",
  colorBgNeutralStrongHover: "#504f54",
  colorBgSuccessDefault: "#23BD7D",
  colorBgSuccessHover: "#41C890",
  colorBgSuccessPressed: "#5FD2A3",
  colorBgSuccessDisabled: "#16784F",
  colorBgSuccessLowDefault: "#0B412B",
  colorBgSuccessLowHover: "#0B412B",
  colorBgSuccessLowPressed: "#0B412B",
  colorBgSuccessSubduedDefault: "#0B412B",
  colorBgSuccessSubduedHover: "#0F5235",
  colorBgSuccessSubduedPressed: "#16784F",
  colorBgCriticalDefault: "#FF7073",
  colorBgCriticalHover: "#FF8D8F",
  colorBgCriticalPressed: "#FFA9AB",
  colorBgCriticalDisabled: "#A74345",
  colorBgCriticalLowDefault: "#4F1618",
  colorBgCriticalLowHover: "#4F1618",
  colorBgCriticalLowPressed: "#4F1618",
  colorBgCriticalStrongDefault: "#FF8D8F",
  colorBgCriticalStrongActive: "#FFA9AB",
  colorBgCriticalSubduedDefault: "#230001",
  colorBgCriticalSubduedHover: "#7B2D2F",
  colorBgCriticalSubduedPressed: "#A74345",
  colorBgWarningDefault: "#ED913B",
  colorBgWarningHover: "#F1A762",
  colorBgWarningPressed: "#F4BD89",
  colorBgWarningDisabled: "#995D25",
  colorBgWarningLowDefault: "#512F10",
  colorBgWarningLowHover: "#512F10",
  colorBgWarningLowPressed: "#512F10",
  colorBgWarningSubduedDefault: "#512F10",
  colorBgWarningSubduedHover: "#603915",
  colorBgWarningSubduedPressed: "#995D25",
  colorBgScaleDefault: "#219475",
  colorBgScaleHover: "#239E7D",
  colorBgScaleSubduedDefault: "#0D3A31",
  colorBgLeadDefault: "#835EC7",
  colorBgLeadHover: "#8D6BCC",
  colorBgLeadSubduedDefault: "#23153d",
  colorBgPrivateDefault: "#2d2c23",
  colorBgPrivateHover: "#343228",
  colorBgPrivateStrongDefault: "#343228",
  colorBgPrivateLowDefault: "#25241d",
  colorBgGradientSubdued: "linear-gradient(180deg, #222326 0%, #1d1d20 100%)",
  colorBgSecondaryDefault: "#c9cbcf",
  colorBgSecondaryDisabled: "#38393d",
  colorBgSecondaryStrongDefault: "#fff",
  colorBgSecondaryStrongHover: "#dfe0e2",
  colorBgSecondaryStrongPressed: "#d1d3d6",
  colorBgSecondaryStrongActive: "#f7f8f9",
  colorBgSecondarySubduedDefault: "#313235",
  colorBgSecondaryLowDefault: "#95989d",
  colorBgSecondaryLowDisabled: "#57585c",
  colorBgInfoDefault: "#5A9DFC",
  colorBgInfoHover: "#7BB1FD",
  colorBgInfoPressed: "#9CC4FD",
  colorBgInfoDisabled: "#3663A1",
  colorBgInfoStrongDefault: "#7BB1FD",
  colorBgInfoLowDefault: "#152E51",
  colorBgInfoLowHover: "#152E51",
  colorBgInfoLowPressed: "#152E51",
  colorBgOverdueDefault: "#db6300",
  colorBgOverdueLowDefault: "#1D1A18",
  colorBgNoconsentDefault: "#1D1A18",
  colorBgNodataDefault: "#1D1A18",
  colorBgTeamDefault: "#6473C6",
  colorBgPersonalDefault: "#B26D00",
  colorBgOverlayDefault: "rgba(0,0,0,0.8)",
  colorBgOnoverlayHover: "rgba(255,255,255,0.1)",
  colorBgOnoverlayPressed: "rgba(255,255,255,0.2)",
  colorBgGhostHover: "rgba(255,255,255,0.1)",
  colorBgGhostPressed: "rgba(255,255,255,0.2)",
  colorBgTintDefault: "rgba(255,255,255,0.3)",
  colorBgLoadingDefault: "rgba(255,255,255,0.15)",
  colorBgOfferDefault: "#AF7FE6",
  colorBgOfferHover: "#BC94EA",
  colorBgOfferPressed: "#CAAAEE",
  colorBgOfferLowDefault: "#432468",
  colorBgOfferLowHover: "#432468",
  colorBgRequisitionSubduedDefault: "#432468",
  colorBgScreeningDefault: "#7BB1FD",
  colorBgScreeningHover: "#9CC4FD",
  colorBgScreeningPressed: "#BDD8FE",
  colorBgScreeningLowDefault: "#152E51",
  colorBgInterviewDefault: "#5A9DFC",
  colorBgInterviewHover: "#7BB1FD",
  colorBgInterviewPressed: "#9CC4FD",
  colorBgInterviewLowDefault: "#152E51",
  colorBgEvaluationDefault: "#00C1CC",
  colorBgEvaluationHover: "#00D0DB",
  colorBgEvaluationPressed: "#00DEEB",
  colorBgEvaluationLowDefault: "#003A3D",
  colorBgEvaluationLowHover: "#003A3D",
  colorBgJobSubduedDefault: "#003A3D",
  colorBgHiredDefault: "#23BD7D",
  colorBgHiredHover: "#41C890",
  colorBgHiredPressed: "#5FD2A3",
  colorBgHiredLowDefault: "#0B412B",
  colorBgTranslateDefault: "#ED913B",
  colorBgChartDefault: "rgba(116,39,248, 0.1)",
  colorBgVersatileSecondaryStrongDefault: "#45454a",
  colorBgVersatileSecondaryStrongHover: "#313135",
  colorBgVersatileSecondaryStrongPressed: "#484c5b",
  colorBgVersatileSecondaryStrongActive: "#3b3b40",
  colorBgVersatileSecondaryDefault: "#5a5f72",
  colorBgVersatileSecondaryHover: "#484C5B",
  colorBgVersatileSecondaryMediumDefault: "#313135",
  colorBgVersatileSecondaryMediumHover: "#404045",
  colorBgVersatileSecondaryMediumActive: "#62626a",
  colorBgSkeletonDefault: "#303236",
  colorBgOncomponentDefault: "#3E3D42",
  colorBgOncomponentHover: "#3E3D42",
  colorBgOncomponentActive: "#3E3D42",
  colorBgOptimizeDefault: "#835EC7",
  colorBgOptimizeHover: "#8D6BCC",
  colorBgOptimizeSubduedDefault: "#23153d",
  colorBgGrowDefault: "#219475",
  colorBgGrowHover: "#219475",
  colorBgGrowSubduedDefault: "#0D3A31",
  colorBgStartDefault: "#ffffff",
  colorBgStartHover: "#dfe0e2",
  colorBgOnboardingDefault: "#922584",
  colorBgOnboardingHover: "#922584",
  colorBgOnboardingLowDefault: "#5B1C52",
  colorBgOnboardingLowActive: "#481741",
  colorBgOnboardingSubduedDefault: "#3D1E39",
  colorBgTellentDefault: "#E83393",
  colorBgTellentHover: "#EC53A4",
  colorBgTellentPressed: "#EF73B5",
  colorBgTellentActive: "#420027",
  colorBgAppliedDefault: "#8997A9",
  colorBgAppliedHover: "#98A4B4",
  colorBgAppliedPressed: "#A7B1BE",
  colorBgAppliedLowDefault: "#35363B",
  colorBgNotypeDefault: "#B38F7F",
  colorBgNotypeHover: "#BD9D8F",
  colorBgNotypePressed: "#C6AB9F",
  colorBgNotypeLowDefault: "#402E26",
  colorBgKiwiDefault: "#00853E",
  colorBgKiwiHover: "#6FB688",
  colorBgKiwiPressed: "#92C8A5",
  colorBgKiwiSubduedHover: "#1A402C",
  colorBgJaveloDefault: "#D14905",
  colorBgJaveloHover: "#5F240B",
  colorBgRecruiteeDefault: "#078fe4",
  colorBgPublicSubduedDefault: "#0D3A31",
  colorBgArticleTurquoiseSubduedDefault: "#003A3D",
  colorBgArticlePurpleSubduedDefault: "#3C156B",
  colorBgAccentDefault: "#FD62B0",
  colorBgAccentHover: "#FD62B0",
  colorBgAccentPressed: "#FD81C0",
  colorBgAccentActive: "#FD62B0",
  colorBgAccentSubduedDefault: "#4E1432",
  colorBgAccentSubduedHover: "#4E1432",
  colorBgAccentSubduedPressed: "#4E1432",
  colorBgAccentStrongDefault: "#FD81C0",
  colorBgImpactDefault: "#A060FF",
  colorBgImpactLowPressed: "#7552A7",
  colorBgImpactSubduedDefault: "#4C376C",
  colorBgImpactSubduedHover: "#683AAB",
  colorBgAttendanceSubduedDefault: "#FFEDF5",
  colorBgEmployeesSubduedDefault: "#FFF3E5",
  colorBgTimeoffSubduedDefault: "#E9F3FF",
  colorBgCompanySubduedDefault: "#EBFAFB",
  colorBgPayrollSubduedDefault: "#F7E6F8",
  colorBgExpensesSubduedDefault: "#E6E6F4",
  colorBgReportsSubduedDefault: "#E8F9EE",
  colorBgQuoteDefault: "#BB89E0",
  colorTextDefault: "#c9cbcf",
  colorTextHover: "#fff",
  colorTextPressed: "#fff",
  colorTextDisabled: "#57585c",
  colorTextActive: "#BF99F6",
  colorTextStrongDefault: "#fff",
  colorTextStrongHover: "#fff",
  colorTextStrongSelected: "#fff",
  colorTextLowDefault: "#95989d",
  colorTextOnprimaryDefault: "#000000",
  colorTextOnprimaryHover: "#000000",
  colorTextOnprimaryPressed: "#000000",
  colorTextOnprimaryDisabled: "#000000",
  colorTextOnprimarySelected: "#000000",
  colorTextOnneutralDisabled: "#6d6b70",
  colorTextOnsuccessDefault: "#000000",
  colorTextOnsuccessHover: "#000000",
  colorTextOnsuccessPressed: "#000000",
  colorTextOncriticalDefault: "#000000",
  colorTextOncriticalHover: "#000000",
  colorTextOncriticalPressed: "#000000",
  colorTextOnwarningDefault: "#000000",
  colorTextOnwarningHover: "#000000",
  colorTextOnwarningPressed: "#000000",
  colorTextSuccessDefault: "#23BD7D",
  colorTextSuccessHover: "#23BD7D",
  colorTextSuccessPressed: "#41C890",
  colorTextSuccessStrongDefault: "#41C890",
  colorTextSuccessStrongHover: "#5FD2A3",
  colorTextSuccessStrongPressed: "#7EDDB5",
  colorTextCriticalDefault: "#FF7073",
  colorTextCriticalHover: "#FF7073",
  colorTextCriticalPressed: "#FF8D8F",
  colorTextCriticalStrongDefault: "#FF8D8F",
  colorTextCriticalStrongHover: "#FFA9AB",
  colorTextCriticalStrongPressed: "#FFC6C7",
  colorTextInfoDefault: "#5A9DFC",
  colorTextInfoHover: "#5A9DFC",
  colorTextInfoPressed: "#7BB1FD",
  colorTextInfoStrongDefault: "#7BB1FD",
  colorTextWarningDefault: "#ED913B",
  colorTextWarningHover: "#ED913B",
  colorTextWarningPressed: "#F1A762",
  colorTextWarningStrongDefault: "#F1A762",
  colorTextWarningStrongHover: "#F4BD89",
  colorTextWarningStrongPressed: "#F8D3B1",
  colorTextOnscaleDefault: "#ffffff",
  colorTextOnscaleHover: "#ffffff",
  colorTextOnleadDefault: "#ffffff",
  colorTextOnleadHover: "#ffffff",
  colorTextScaleDefault: "#219475",
  colorTextScaleHover: "#239E7D",
  colorTextOngradientDefault: "#000000",
  colorTextLeadDefault: "#835EC7",
  colorTextOnsecondaryDefault: "#ffffff",
  colorTextOnsecondaryStrongDefault: "#ffffff",
  colorTextOnsecondaryStrongHover: "#ffffff",
  colorTextOnsecondaryStrongPressed: "#ffffff",
  colorTextOninfoStrongDefault: "#000000",
  colorTextOninfoDefault: "#000000",
  colorTextOninfoHover: "#000000",
  colorTextOninfoPressed: "#000000",
  colorTextOverdueDefault: "#db6300",
  colorTextOnoverdueDefault: "#ffffff",
  colorTextNoconsentDefault: "#db6300",
  colorTextNodataDefault: "#db6300",
  colorTextOnoverlayDefault: "#ffffff",
  colorTextOnoverlayHover: "#ffffff",
  colorTextOnoverlayPressed: "#ffffff",
  colorTextOnoverlayDisabled: "#95989d",
  colorTextOnoverlayLowDefault: "#36353b",
  colorTextOnghostDefault: "#ffffff",
  colorTextOnghostHover: "#ffffff",
  colorTextOnghostPressed: "#ffffff",
  colorTextOnghostDisabled: "#95989d",
  colorTextPrimaryDefault: "#AF80F4",
  colorTextPrimaryActive: "#AF80F4",
  colorTextPrimaryHover: "#BF99F6",
  colorTextPrimaryPressed: "#BF99F6",
  colorTextPrimaryStrongDefault: "#BF99F6",
  colorTextPrimaryStrongActive: "#BF99F6",
  colorTextOnteamDefault: "#ffffff",
  colorTextOncomponentDefault: "#ffffff",
  colorTextOnoptimizeDefault: "#ffffff",
  colorTextOnoptimizeHover: "#ffffff",
  colorTextOptimizeDefault: "#835EC7",
  colorTextOptimizeHover: "#8D6BCC",
  colorTextOngrowDefault: "#ffffff",
  colorTextOngrowHover: "#ffffff",
  colorTextGrowDefault: "#219475",
  colorTextGrowHover: "#239E7D",
  colorTextOnstartDefault: "#0E0E0F",
  colorTextOnstartHover: "#0E0E0F",
  colorTextOnboardingLowDefault: "#E7D1EB",
  colorTextOnboardingDefault: "#FFFFFF",
  colorTextOnonboardingDefault: "#ffffff",
  colorTextOnonboardingHover: "#ffffff",
  colorTextOntellentDefault: "#ffffff",
  colorTextOntellentHover: "#ffffff",
  colorTextOntellentPressed: "#ffffff",
  colorTextOnappliedDefault: "#000000",
  colorTextOnappliedHover: "#000000",
  colorTextOnappliedPressed: "#000000",
  colorTextOnscreeningDefault: "#000000",
  colorTextOnscreeningHover: "#000000",
  colorTextOnscreeningPressed: "#000000",
  colorTextOninterviewDefault: "#000000",
  colorTextOninterviewHover: "#000000",
  colorTextOninterviewPressed: "#000000",
  colorTextOnevaluationDefault: "#000000",
  colorTextOnevaluationHover: "#000000",
  colorTextOnevaluationPressed: "#000000",
  colorTextOnofferDefault: "#000000",
  colorTextOnofferHover: "#000000",
  colorTextOnofferPressed: "#000000",
  colorTextOnhiredDefault: "#000000",
  colorTextOnhiredHover: "#000000",
  colorTextOnhiredPressed: "#000000",
  colorTextOnnotypeDefault: "#000000",
  colorTextOnnotypeHover: "#000000",
  colorTextOnnotypePressed: "#000000",
  colorTextOnkiwiDefault: "#ffffff",
  colorTextOnkiwiHover: "#ffffff",
  colorTextOnkiwiPressed: "#ffffff",
  colorTextOnjaveloDefault: "#ffffff",
  colorTextOnrecruiteeDefault: "#ffffff",
  colorTextRecruiteeDefault: "#078fe4",
  colorTextRecruiteeStrongDefault: "#429ed7",
  colorTextKiwiDefault: "#00853E",
  colorTextKiwiStrongDefault: "#6FB688",
  colorTextAccentDefault: "#FD62B0",
  colorTextAccentHover: "#FD81C0",
  colorTextAccentPressed: "#FD81C0",
  colorTextOnaccentDefault: "#000000",
  colorTextOnaccentHover: "#000000",
  colorTextOnaccentPressed: "#000000",
  colorTextImpactDefault: "#A060FF",
  colorTextImpactHover: "#CCABFF",
  colorTextImpactPressed: "#CCABFF",
  colorTextAiDefault: "#8066e5",
  colorIconDefault: "#c9cbcf",
  colorIconHover: "#fff",
  colorIconPressed: "#fff",
  colorIconDisabled: "#57585c",
  colorIconActive: "#7BB1FD",
  colorIconStrongDefault: "#fff",
  colorIconOnprimaryDefault: "#000000",
  colorIconOnprimaryHover: "#000000",
  colorIconOnprimaryPressed: "#000000",
  colorIconOnprimaryDisabled: "#000000",
  colorIconOnneutralDisabled: "#6d6b70",
  colorIconOnsuccessDefault: "#000000",
  colorIconOnsuccessHover: "#000000",
  colorIconOnsuccessPressed: "#000000",
  colorIconOnsuccessDisabled: "#000000",
  colorIconOncriticalDefault: "#000000",
  colorIconOncriticalHover: "#000000",
  colorIconOncriticalPressed: "#000000",
  colorIconOnwarningDefault: "#000000",
  colorIconOnwarningHover: "#000000",
  colorIconOnwarningPressed: "#000000",
  colorIconSuccessDefault: "#23BD7D",
  colorIconSuccessHover: "#23BD7D",
  colorIconSuccessPressed: "#41C890",
  colorIconSuccessActive: "#5FD2A3",
  colorIconSuccessStrongDefault: "#41C890",
  colorIconSuccessStrongHover: "#5FD2A3",
  colorIconSuccessStrongPressed: "#7EDDB5",
  colorIconCriticalDefault: "#FF7073",
  colorIconCriticalHover: "#FF7073",
  colorIconCriticalPressed: "#FF8D8F",
  colorIconCriticalStrongDefault: "#FF8D8F",
  colorIconCriticalStrongHover: "#FFA9AB",
  colorIconCriticalStrongPressed: "#FFC6C7",
  colorIconInfoDefault: "#5A9DFC",
  colorIconInfoHover: "#5A9DFC",
  colorIconInfoPressed: "#7BB1FD",
  colorIconInfoStrongDefault: "#7BB1FD",
  colorIconWarningDefault: "#ED913B",
  colorIconWarningHover: "#ED913B",
  colorIconWarningPressed: "#F1A762",
  colorIconWarningStrongDefault: "#F1A762",
  colorIconWarningStrongHover: "#F4BD89",
  colorIconWarningStrongPressed: "#F8D3B1",
  colorIconScaleDefault: "#219475",
  colorIconScaleHover: "#239E7D",
  colorIconOngradientDefault: "#000000",
  colorIconOnscaleDefault: "#ffffff",
  colorIconOnscaleHover: "#ffffff",
  colorIconLeadDefault: "#835EC7",
  colorIconOnleadDefault: "#ffffff",
  colorIconOnleadHover: "#ffffff",
  colorIconOnsecondaryDefault: "#ffffff",
  colorIconOnsecondaryStrongDefault: "#ffffff",
  colorIconOnsecondaryStrongHover: "#ffffff",
  colorIconOninfoStrongDefault: "#000000",
  colorIconOninfoDefault: "#000000",
  colorIconOninfoHover: "#000000",
  colorIconOninfoPressed: "#000000",
  colorIconOverdueDefault: "#db6300",
  colorIconOnoverdueDefault: "#ffffff",
  colorIconNoconsentDefault: "#db6300",
  colorIconNodataDefault: "#db6300",
  colorIconOnoverlayDefault: "#ffffff",
  colorIconOnoverlayHover: "#ffffff",
  colorIconOnoverlayPressed: "#ffffff",
  colorIconOnoverlayDisabled: "#95989d",
  colorIconOnghostDefault: "#ffffff",
  colorIconOnghostHover: "#ffffff",
  colorIconOnghostPressed: "#ffffff",
  colorIconOnghostDisabled: "#95989d",
  colorIconPrimaryDefault: "#AF80F4",
  colorIconPrimaryHover: "#BF99F6",
  colorIconPrimaryPressed: "#AF80F4",
  colorIconPrimaryStrongDefault: "#BF99F6",
  colorIconPrimaryStrongPressed: "#BF99F6",
  colorIconLowDefault: "#95989d",
  colorIconLowDisabled: "#504f54",
  colorIconSubduedDefault: "#313235",
  colorIconOncomponentDefault: "#ffffff",
  colorIconAiDefault: "#8066e5",
  colorIconTranslateDefault: "#ED913B",
  colorIconOptimizeDefault: "#835EC7",
  colorIconOptimizeHover: "#8D6BCC",
  colorIconOnoptimizeDefault: "#ffffff",
  colorIconOnoptimizeHover: "#ffffff",
  colorIconGrowDefault: "#219475",
  colorIconGrowHover: "#239E7D",
  colorIconOngrowDefault: "#ffffff",
  colorIconOngrowHover: "#ffffff",
  colorIconOnboardingDefault: "#922584",
  colorIconOnboardingLowDefault: "#E7D1EB",
  colorIconOnonboardingDefault: "#ffffff",
  colorIconOnonboardingHover: "#ffffff",
  colorIconOnhiredDefault: "#000000",
  colorIconOnhiredHover: "#000000",
  colorIconOnhiredPressed: "#000000",
  colorIconOnkiwiDefault: "#ffffff",
  colorIconOnkiwiHover: "#ffffff",
  colorIconOnkiwiPressed: "#ffffff",
  colorIconOnjaveloDefault: "#ffffff",
  colorIconOnappliedDefault: "#000000",
  colorIconOnappliedHover: "#000000",
  colorIconOnappliedPressed: "#000000",
  colorIconOnscreeningDefault: "#000000",
  colorIconOnscreeningHover: "#000000",
  colorIconOnscreeningPressed: "#000000",
  colorIconOninterviewDefault: "#000000",
  colorIconOninterviewHover: "#000000",
  colorIconOninterviewPressed: "#000000",
  colorIconOnnotypeDefault: "#000000",
  colorIconOnnotypeHover: "#000000",
  colorIconOnnotypePressed: "#000000",
  colorIconOnevaluationDefault: "#000000",
  colorIconOnevaluationHover: "#000000",
  colorIconOnevaluationPressed: "#000000",
  colorIconOnofferDefault: "#000000",
  colorIconOnofferHover: "#000000",
  colorIconOnofferPressed: "#000000",
  colorIconOntellentDefault: "#ffffff",
  colorIconOntellentHover: "#ffffff",
  colorIconOntellentPressed: "#ffffff",
  colorIconTellentDefault: "#E83393",
  colorIconTellentActive: "#E83393",
  colorIconOfferDefault: "#AF7FE6",
  colorIconEvaluationDefault: "#00C1CC",
  colorIconPublicDefault: "#219475",
  colorIconRecruiteeDefault: "#078fe4",
  colorIconKiwiDefault: "#00853E",
  colorIconRequisitionDefault: "#AF7FE6",
  colorIconJobDefault: "#00C1CC",
  colorIconArticleTurquoiseDefault: "#009199",
  colorIconArticlePurpleDefault: "#863EDA",
  colorIconAccentDefault: "#FD62B0",
  colorIconAccentHover: "#FD62B0",
  colorIconAccentPressed: "#FD81C0",
  colorIconOnaccentDefault: "#ffffff",
  colorIconOnaccentHover: "#ffffff",
  colorIconOnaccentPressed: "#ffffff",
  colorIconImpactDefault: "#A060FF",
  colorIconImpactHover: "#CCABFF",
  colorIconImpactPressed: "#CCABFF",
  colorIconAttendanceDefault: "#F65978",
  colorIconEmployeesDefault: "#FFAA45",
  colorIconTimeoffDefault: "#61A5FF",
  colorIconCompanyDefault: "#34D0D7",
  colorIconPayrollDefault: "#C746CB",
  colorIconExpensesDefault: "#0E0BC7",
  colorIconReportsDefault: "#56D586",
  colorBorderAiDefault: "#8066e5",
  colorBorderDefault: "#414045",
  colorBorderHover: "#414045",
  colorBorderPressed: "#414045",
  colorBorderDisabled: "#36353b",
  colorBorderSelected: "#414045",
  colorBorderActive: "#724EA7",
  colorBorderSuccessDefault: "#23BD7D",
  colorBorderSuccessHover: "#23BD7D",
  colorBorderSuccessPressed: "#41C890",
  colorBorderSuccessSubduedDefault: "#0F5235",
  colorBorderSuccessLowDefault: "#1D9B66",
  colorBorderCriticalDefault: "#FF7073",
  colorBorderCriticalHover: "#FF7073",
  colorBorderCriticalPressed: "#FF8D8F",
  colorBorderCriticalLowDefault: "#A74345",
  colorBorderCriticalSubduedDefault: "#7B2D2F",
  colorBorderInfoDefault: "#5A9DFC",
  colorBorderInfoHover: "#5A9DFC",
  colorBorderInfoPressed: "#7BB1FD",
  colorBorderInfoSubduedDefault: "#1D3A63",
  colorBorderWarningDefault: "#ED913B",
  colorBorderWarningHover: "#ED913B",
  colorBorderWarningPressed: "#F1A762",
  colorBorderWarningDisabled: "#995D25",
  colorBorderWarningSubduedDefault: "#603915",
  colorBorderNeutralHover: "#504f54",
  colorBorderNeutralDisabled: "#1B1C1E",
  colorBorderOncomponentDefault: "#222326",
  colorBorderSecondaryDefault: "#c9cbcf",
  colorBorderSecondaryHover: "#fff",
  colorBorderSecondaryDisabled: "#57585c",
  colorBorderSecondaryLowDefault: "#95989d",
  colorBorderSecondaryLowDisabled: "#494b50",
  colorBorderSecondaryStrongDefault: "#dfe0e2",
  colorBorderPrimaryDefault: "#AF80F4",
  colorBorderPrimaryHover: "#BF99F6",
  colorBorderPrimaryStrongDefault: "#BF99F6",
  colorBorderPrimarySubduedDefault: "#543680",
  colorBorderPrimaryLowDefault: "#9167CD",
  colorBorderTranslateDefault: "#ED913B",
  colorBorderOnghostDefault: "#ffffff",
  colorBorderOnghostHover: "#ffffff",
  colorBorderOnghostPressed: "#ffffff",
  colorBorderOnghostDisabled: "#95989d",
  colorBorderPrivateDefault: "#444336",
  colorBorderStrongDefault: "#504f54",
  colorBorderStrongDisabled: "#504f54",
  colorBorderLowDefault: "#36353b",
  colorBorderLowHover: "#313235",
  colorBorderTeamDefault: "#6473C6",
  colorBorderVersatileSecondaryDefault: "#57565d",
  colorBorderTintDefault: "rgba(255,255,255,0.3)",
  colorBorderAccentDefault: "#FD62B0",
  colorBorderAccentHover: "#FD62B0",
  colorBorderAccentPressed: "#FD81C0",
  colorBorderAccentSubduedDefault: "#7A2751",
  colorBorderImpactDefault: "#7552A7",
  colorBorderImpactHover: "#7552A7",
  colorBorderImpactPressed: "#7552A7",
  colorGradientPrimary: "linear-gradient(270deg, #078FE4 0%, #163EA2 100%)",
  colorGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  colorGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  colorGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  colorGradientPurple: "linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)",
  colorGradientOrange: "linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)",
  colorGradientRed: "linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)",
  colorGradientLightBlue: "linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)",
  colorGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  colorGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  colorGradientFindTimeNeutral: "repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)",
  colorGradientFindTimePrimary: "repeating-linear-gradient(135deg, #362252, #362252 6px, #4B336F 6px, #4B336F 12px)",
  colorGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  colorGradientTruncate: "#e8198a00",
  colorGradientShimmer: "linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%",
  colorGradientRainbow: "linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)",
  colorGradientNeutralToTransparent: "linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)",
  colorGradientTellent: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  colorGradientPink: "linear-gradient(90deg, #af80f4 0%, #fd62b0 100%)",
  colorGradientImpact: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
  colorGradientAi: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
  colorGradientGrowCopy: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
  colorTooltipFeature: "#0C285E",
  colorTooltipFeatureLight: "#0988DE",
  colorAvatarSteelLighter: "#ad94e0",
  colorAvatarSteelLight: "#313235",
  colorAvatarSteelDark: "#61636b",
  colorAvatarGrayLight: "#414045",
  colorAvatarGrayDark: "#838288",
  colorAvatarGreen: "#239E7D",
  colorAvatarBlueLight: "#5A9DFC",
  colorAvatarBlueDark: "#bd6bb3",
  colorAvatarBlueDarker: "#DFCCFB",
  colorAvatarPink: "#9A4CB6",
  colorAvatarPurple: "#8D6BCC",
  colorAvatarYellow: "#ED913B",
  colorAvatarOrange: "#db6300",
  colorAvatarSkeleton: "#2E2F33",
  colorChartPrimaryDefault: "#8659CA",
  colorChartBlueDefault: "#F47174",
  colorChartTurquoiseDefault: "#008EE5",
  colorChartPurpleDefault: "#E566A5",
  colorChartPurpleSubduedDefault: "#03AD9C",
  colorChartGrayDefault: "#A6A2AF",
  colorChartGreenDefault: "#45C2D1",
  colorChartGreenSubduedDefault: "#CD75BC",
  colorChartBlueStrongDefault: "#FFD76F",
  colorChartYellowDefault: "#FEB07B",
  colorChartYellowSubduedDefault: "#6871EE",
  colorChartOrangeDefault: "#B2A1F7",
  colorSeparatorTransparent: "rgba(0,0,0,0.2)",
  colorLogoTypographyDefault: "#B57FEF",
  colorLogoTypographyStrongDefault: "#ECE0F5",
  colorLogoSignSubduedDefault: "#350B51",
  colorLogoSignPrimaryDefault: "#B57FEF",
  colorLogoSignAccentDefault: "#EE5FB2",
  colorCandidatesBgPrimaryDefault: "#0789D9",
  colorCandidatesBgGreenStrongDefault: "#1a8e68",
  colorCandidatesBgOrangeDefault: "#c45a03",
  colorCandidatesBgYellowDefault: "#f2b10d",
  colorCandidatesBgGreenSubduedDefault: "#2caa86",
  colorCandidatesBgBlueDefault: "#0C6090",
  colorCandidatesBgVioletDefault: "#512FA2",
  colorCandidatesBgGreenDefault: "#46af0e",
  colorCandidatesBgBlueStrongDefault: "#083F5E",
  colorCandidatesBgPurpleDefault: "#8c44a7",
  colorCandidatesBorderPrimaryDefault: "#1999E3",
  colorCandidatesBorderGreenStrongDefault: "#1a8e68",
  colorCandidatesBorderOrangeDefault: "#c45a03",
  colorCandidatesBorderYellowDefault: "#f2b10d",
  colorCandidatesBorderGreenSubduedDefault: "#2caa86",
  colorCandidatesBorderBlueDefault: "#0C6090",
  colorCandidatesBorderVioletDefault: "#512FA2",
  colorCandidatesBorderGreenDefault: "#46af0e",
  colorCandidatesBorderBlueStrongDefault: "#083F5E",
  colorCandidatesBorderPurpleDefault: "#8c44a7",
  colorScrollbarThumbDefault: "#5A5A5A",
  colorScrollbarThumbHover: "#737373",
  colorScrollbarTrackDefault: "#2E2F30",
  colorMarketplaceLogo: "#FFFFFF",
  colorMarketplaceRibbon: "#16784F",
  colorVersatileDefault: "#ffffff",
  colorFacebookDefault: "#1877F2",
  colorLinkedinDefault: "#2187EC",
  colorGoogleplusDefault: "#d34836",
  colorXDefault: "#C4C4C4",
  colorNavBgNeutralDefault: "#1B1C1E",
  colorNavBgNeutralLowHover: "#36353b",
  colorNavBgActive: "#3d2c56",
  colorNavBgPrimarySubduedDefault: "#3F2961",
  colorNavTextDefault: "#c9cbcf",
  colorNavTextStrongDefault: "#fff",
  colorNavTextPrimaryActive: "#AF80F4",
  colorNavTextLowDefault: "#95989d",
  colorNavIconDefault: "#c9cbcf",
  colorNavIconStrongDefault: "#fff",
  colorNavIconPrimaryDefault: "#AF80F4",
  colorNavIconDisabled: "#57585c",
  colorNavBorderDefault: "#414045",
  tellentShadowBorderFormFocusDefault: [{"x":"0","y":"0","blur":"0","spread":"3","color":"rgba(175,128,244,0.3)","type":"dropShadow"}],
  kiwiShadowBorderFormFocusDefault: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(0,133,62,0.2)","type":"dropShadow"}],
  tellentShadowBorderCardActive: [{"x":"0","y":"0","blur":"0","spread":"4","color":"rgba(232,51,147,0.2)","type":"dropShadow"}],
  kiwiShadowBorderCardActive: [{"x":"0","y":"0","blur":"0","spread":"4","color":"rgba(0,120,56,0.2)","type":"dropShadow"}],
  tellentShadowBorderCardHover: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(232,51,147,1)","type":"dropShadow"}],
  kiwiShadowBorderCardHover: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(0,120,56,1)","type":"dropShadow"}],
  avatarSteelLighter: "#ad94e0",
  avatarSteelLight: "#313235",
  avatarSteelDark: "#61636b",
  avatarGrayLight: "#414045",
  avatarGrayDark: "#838288",
  avatarGreen: "#239E7D",
  avatarBlueLight: "#5A9DFC",
  avatarBlueDark: "#bd6bb3",
  avatarBlueDarker: "#DFCCFB",
  avatarPink: "#9A4CB6",
  avatarPurple: "#8D6BCC",
  avatarYellow: "#ED913B",
  avatarOrange: "#db6300",
  avatarSkeleton: "#2E2F33",
  chartBrandDefault: "#8659CA",
  chartSkyDefault: "#F47174",
  chartOceanDefault: "#008EE5",
  chartOrchidDefault: "#E566A5",
  chartLavenderDefault: "#03AD9C",
  chartSteelDefault: "#A6A2AF",
  chartEmeraldDefault: "#45C2D1",
  chartMintDefault: "#CD75BC",
  chartCobaltDefault: "#FFD76F",
  chartSunflowerDefault: "#FEB07B",
  chartLemonDefault: "#6871EE",
  chartPumpkinDefault: "#B2A1F7",
  candidatesBgBrandDefault: "#0789D9",
  candidatesBgRainforestDefault: "#1a8e68",
  candidatesBgFireDefault: "#c45a03",
  candidatesBgGoldDefault: "#f2b10d",
  candidatesBgJungleDefault: "#2caa86",
  candidatesBgNavyDefault: "#0C6090",
  candidatesBgEggplantDefault: "#512FA2",
  candidatesBgGrassDefault: "#46af0e",
  candidatesBgDenimDefault: "#083F5E",
  candidatesBgLilacDefault: "#8c44a7",
  candidatesBorderBrandDefault: "#1999E3",
  candidatesBorderRainforestDefault: "#1a8e68",
  candidatesBorderFireDefault: "#c45a03",
  candidatesBorderGoldDefault: "#f2b10d",
  candidatesBorderJungleDefault: "#2caa86",
  candidatesBorderNavyDefault: "#0C6090",
  candidatesBorderEggplantDefault: "#512FA2",
  candidatesBorderGrassDefault: "#46af0e",
  candidatesBorderDenimDefault: "#083F5E",
  candidatesBorderLilacDefault: "#8c44a7",
  aiDefault: "#927ce9",
  productRecruitee50: "#322447",
  productRecruitee100: "#3d2c56",
  productRecruitee200: "#543680",
  productRecruitee300: "#724EA7",
  productRecruitee400: "#9167CD",
  productRecruitee500: "#AF80F4",
  productRecruitee600: "#BF99F6",
  productRecruitee700: "#CFB3F8",
  productRecruitee800: "#DFCCFB",
  productRecruitee900: "#E7D9FC",
  productKiwi50: "#0F2115",
  productKiwi100: "#1A402C",
  productKiwi200: "#1E422B",
  productKiwi300: "#2E6240",
  productKiwi400: "#3D8356",
  productKiwi500: "#00853E",
  productKiwi600: "#009E4A",
  productKiwi700: "#00B856",
  productKiwi800: "#00D162",
  productKiwi900: "#00EB6D",
  productJavelo50: "#2A0F01",
  productJavelo100: "#5F240B",
  productJavelo200: "#541D02",
  productJavelo300: "#7D2C03",
  productJavelo400: "#A73A04",
  productJavelo500: "#D14905",
  productJavelo600: "#DA6931",
  productJavelo700: "#E38A5D",
  productJavelo800: "#ECAA89",
  productJavelo900: "#F0BA9F",
  productTellent50: "#260016",
  productTellent100: "#420027",
  productTellent200: "#5E0B37",
  productTellent300: "#951B5C",
  productTellent400: "#CC287F",
  productTellent500: "#E83393",
  productTellent600: "#EC53A4",
  productTellent700: "#EF73B5",
  productTellent800: "#F6B3D7",
  productTellent900: "#FCE3F0",
  onboardingBackgroundDefault: "#922584",
  onboardingBackgroundLoader: "#481741",
  onboardingBackgroundLow: "#5B1C52",
  onboardingBackgroundSubdued: "#3D1E39",
  onboardingTextDefault: "#FFFFFF",
  onboardingTextLow: "#E7D1EB",
  onboardingIconDefault: "#922584",
  onboardingIconLow: "#E7D1EB",
  articleOceanDefault: "#009199",
  articleOceanSubduedDefault: "#003A3D",
  articleOrchidDefault: "#863EDA",
  articleOrchidSubduedDefault: "#3C156B",
  billingPink: "#F65978",
  billingPinkLight: "#FFEDF5",
  billingOrange: "#FFAA45",
  billingOrangeLight: "#FFF3E5",
  billingBlue: "#61A5FF",
  billingBlueLight: "#E9F3FF",
  billingTurquoise: "#34D0D7",
  billingTurquoiseLight: "#EBFAFB",
  billingPurple: "#C746CB",
  billingPurpleLight: "#F7E6F8",
  billingNavy: "#0E0BC7",
  billingNavyLight: "#E6E6F4",
  billingGreen: "#56D586",
  billingGreenLight: "#E8F9EE",
};
